import { localize } from 'vee-validate'
import ja from './ja.js'

// install and activate vee-validate locales
const locales = {
  install(Vue) {
    localize('ja', ja)
  }
}

export default locales
